import { defineStore } from "#src/stores/state-wrapper.ts";
import { examRequiredBackendCheck } from "#src/services/http-electronic-applications.service.ts";
import { STEP } from "#src/constants/step.ts";
import { useEappStore } from "#src/stores/electronic-application.ts";

import { useStepSignatureWaitingStore } from "#src/stores/step-signature-waiting.ts";
import { useStepUnderwritingStore } from "#src/stores/step-underwriting.ts";
import { type Pinia, type StoreGeneric } from "pinia";
import { computed } from "vue";
import { type BaseStepStore } from "#src/types/StepStore.ts";

function initializeExamSchedulingStep(pinia: Pinia): BaseStepStore {
  const step = computed(() => STEP.EXAM_SCHEDULING);
  const previous = computed(() => {
    const underwriting = useStepUnderwritingStore(pinia);
    return underwriting.step;
  });
  const next = computed(() => {
    const signatureWaiting = useStepSignatureWaitingStore(pinia);
    return signatureWaiting.step;
  });

  function beforeLoadAction() {
    const eapp = useEappStore(pinia);
    if (!eapp.id) throw "Missing Eapp ID";
    return examRequiredBackendCheck(pinia, eapp.id);
  }

  function $reset() {}

  return {
    $reset,
    step,
    previous,
    next,
    beforeLoadAction,
  };
}

export function useStepExamSchedulingStore(pinia: Pinia, hot?: StoreGeneric) {
  return defineStore<string, BaseStepStore>("step-exam-scheduling", () => {
    return initializeExamSchedulingStep(pinia);
  })(pinia, hot);
}
